import Dictionary from './Type';

const pt_brDictionary: Dictionary = {
    or: 'ou',
    and: 'e',
    greeting: 'Olá',
    userName: 'Usuário',
    close: 'Fechar',
    welcomeBack: 'Bem-vindo de volta!',
    welcome: 'Bem-vindo!',
    loading: 'Carregando...',
    language: 'Idioma',
    game: {
        self: 'Jogo',
        title: 'Jogo da Forca',
        singleplayer: 'Um Jogador',
        multiplayer: 'Mais Jogadores',
        youWin: 'Você ganhou!',
        youLose: 'Você perdeu!',
        theWordWas: 'A palavra era',
        chooseWord: 'Escreva a palavra',
        generateRandomWord: 'Gerar palavra aleatória',
        chooseLetter: 'Escolha uma letra',
        confirm: 'Confirmar',
        clear: 'Limpar',
        showHideWord: 'Mostrar/Ocultar palavra',
        wrongLetters: 'Letras erradas',
        difficulty: 'Dificuldade',
        chooseDifficulty: 'Defina a dificuldade',
        start: 'Iniciar',
        easy: 'Fácil',
        medium: 'Médio',
        hard: 'Difícil',
        placeholder: 'Palavra',
        type: "Digite",
    },
};

export default pt_brDictionary;
